import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import { ReducerMethods } from "../../store/reducer.methods";
import { API_DOMENS, BASE_API_PAGE_ENUMS } from "../../../constants/apis.constants";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import { CallToast } from "../../../Components/PriceCalculator/modals/CustomToast";
import type GetMemberDetailsDto from "./dto/get-member-details.dto";
import type GetClientAccessDetailsDto from "./dto/get-client-access-details.dto";

export const MemberDetailsEffectActions = {
  getMemberDetails: `${Entities.MemberDetails}_getMemberDetails`,
  getClientAccessDetails: `${Entities.MemberDetails}_getClientAccessDetails`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.MemberDetails,
  initSchema,
  aliasName: DIContainerKeys.MemberDetailsService,
})
export class MemberDetailsService extends HttpService {
  @loader(Loaders.GetMemberDetailsLoader)
  @action(DIContainerKeys.MemberDetailsService)
  public *getMemberDetails(dto: GetMemberDetailsDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.GetMemberDetailsLoader, true);
    const response = yield call(
      this.get,
      {
        url: this.pageEnum(BASE_API_PAGE_ENUMS.GetMemberDetails),
        domain: API_DOMENS.CC_API,
        params: {
          optionEnum1: 1,
          optionEnum2: 20,
          optionEnum3: 1,
        }
      },
      ReducerMethods.UPDATE
    );
    if (!response?.mr?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.GetMemberDetailsLoader, false);
      return;
    }
    yield this.setEntityStateById(Entities.MemberDetails, dto.clientId, response);
    yield this.setLoaderState(Loaders.GetMemberDetailsLoader, false);
  }

  @loader(Loaders.GetClientAccessDetailsLoader)
  @action(DIContainerKeys.MemberDetailsService)
  public *getClientAccessDetails(dto: GetClientAccessDetailsDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.GetClientAccessDetailsLoader, true);
    const response = yield call(
      this.get,
      {
        url: this.pageEnum(BASE_API_PAGE_ENUMS.GetClientAccessDetails),
        domain: API_DOMENS.CC_API,
        params: {
          optionEnum1: dto.clientId,
          optionEnum2: 1,
          optionEnum3: 20,
          optionEnum4: dto.ascendingOrder,
        }
      },
      ReducerMethods.UPDATE
    );
    if (!response?.mr?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.GetClientAccessDetailsLoader, false);
      return;
    }
    yield this.setEntityStateById(Entities.MemberDetails, dto.clientId, response);
    yield this.setLoaderState(Loaders.GetClientAccessDetailsLoader, false);
  }
}